export default "__VITE_ASSET__Nt05hL4z__"